import React, { Suspense, lazy } from 'react';
import { Layout, Result, FloatButton } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HeaderNav from './NavBar/HeaderNav';
import utils from '../module/utils';
import FooterContent from './Footer/FooterContent';
import common from '../module/common';
import TopBackground from '../pages/comps/TopBackground/TopBackground';

const { Content, Footer } = Layout;
const { BackTop } = FloatButton;
const Home = lazy(() => import("../pages/Home/Home"));
const Curation = lazy(() => import("../pages/Curation/Curation"));
const ProjectDetail = lazy(() => import("../pages/ProjectDetail/ProjectDetail"));
const Search = lazy(() => import("../pages/Search/Search"));
const SearchResult = lazy(() => import("../pages/SearchResult/SearchResult"));
const GSEDetail = lazy(() => import("../pages/GSEDetail/GSEDetail"));
const Analysis = lazy(() => import("../pages/Analysis/Analysis"));
const Help = lazy(() => import("../pages/Help/Help"));
const Contact = lazy(() => import("../pages/Contact/Contact"));

export default function Router() {

    React.useEffect(() => {
        common.initProject();
    },[]);

    return (
        <React.Fragment>
            <BrowserRouter>
                <Layout style={{minHeight: "100vh"}} >
                    <TopBackground/>
                    <Content>
                        <Suspense fallback={<Result icon={<LoadingOutlined/>} title="Now loading, please wait..." />} >
                            {/* <BrowserRouter> */}
                                <HeaderNav />
                                <Routes> 
                                    <Route path='/' >
                                        <Route index element={<Home />} />
                                        <Route path='curation' element={<Curation />} />
                                        <Route path='project' element={<ProjectDetail />}>
                                            <Route path=':projectId' element={<ProjectDetail />} />
                                        </Route>
                                        <Route path='search' element={<Search />} >
                                            <Route path=':projectId' element={<Search />} />
                                        </Route>
                                        <Route path='searchResult' element={<SearchResult />} />
                                        <Route path='GSEDetail' element={<GSEDetail />}>
                                            <Route path=':gseId' element={<GSEDetail />} />
                                            <Route path=':gseId/:projectId' element={<GSEDetail />} />
                                        </Route>
                                        <Route path='analysis' element={<Analysis />} />
                                        <Route path='help' element={<Help />} />
                                        <Route path='contact' element={<Contact />} />
                                    </Route>
                                </Routes>
                            {/* </BrowserRouter> */}
                            {/* <BackTop /> */}
                        </Suspense>
                    </Content>
                    <Footer style={{padding: "0px"}} >
                        <FooterContent/>
                    </Footer>
                </Layout>
            </BrowserRouter>
        </React.Fragment>
    )
}